export default __webpack_public_path__ + "static/media/Game_3_Sound_Loop.f0a1479e.wav";